import { StringUtility } from '@common/utils';
import { ExamCategoryModel, IExamCategoryModel } from './ExamCategoryModel';
import {
  ExamResultTypeModel,
  IExamResultTypeModel,
} from './ExamResultTypeModel';
import { ISyncModel, SyncModel } from '@common/models/SyncModel';
import {
  IVisitExamResultObservationModel,
  VisitExamResultObservationModel,
} from './VisitExamResultObservationModel';

export interface IVisitExamResultModel extends ISyncModel {
  visitExamResultId: number;
  visitId: number;
  examCategoryId: number;
  examResultTypeId: number | undefined;
  notes: string | undefined;
  examCategory: IExamCategoryModel;
  examResultType: IExamResultTypeModel | undefined;
  observations: IVisitExamResultObservationModel[];
}

export class VisitExamResultModel
  extends SyncModel
  implements Record<keyof IVisitExamResultModel, any>
{
  visitExamResultId: number;
  visitId: number;
  examCategoryId: number;
  examResultTypeId: number | undefined;
  notes: string | undefined;
  examCategory: ExamCategoryModel;
  examResultType: ExamResultTypeModel | undefined;
  observations: VisitExamResultObservationModel[];

  constructor(params: IVisitExamResultModel) {
    super(params);
    this.visitExamResultId = params.visitExamResultId;
    this.visitId = params.visitId;
    this.examCategoryId = params.examCategoryId;
    this.examResultTypeId = StringUtility.SanitizeNumber(
      params.examResultTypeId,
    );
    this.notes = StringUtility.SanitizeString(params.notes);
    this.examCategory = new ExamCategoryModel(params.examCategory);
    this.examResultType = params.examResultType
      ? new ExamResultTypeModel(params.examResultType)
      : undefined;
    this.observations = (params.observations ?? []).map(
      (o) => new VisitExamResultObservationModel(o),
    );
  }
}
